module.exports = __webpack_public_path__ + "static/dashboard-b94b49f60cf1fccda402f9e255b1d23f.png";